module.exports = __webpack_public_path__ + "img/moaraveche.fbc9ec62.jpeg";